var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('number',_vm._b({attrs:{"format":{
    style: 'currency',
    currency: 'BRL',
  }},scopedSlots:_vm._u([(_vm.hideSymbol)?{key:"currency",fn:function(){return undefined},proxy:true}:null,(_vm.hideSymbol)?{key:"literal",fn:function(){return undefined},proxy:true}:null,(_vm.hideDecimals)?{key:"decimal",fn:function(){return undefined},proxy:true}:null,(_vm.hideDecimals)?{key:"fraction",fn:function(){return undefined},proxy:true}:null],null,true)},'number',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }